import styleConfig from '../../muiTheme';

const styles = () => {
  const {
    palette: {
      gray: { grayC },
      primary: { main },
      whiteOpacity8,
    },
  } = styleConfig;
  return {
    bottomFooter: {
      height: 40,
      backgroundColor: whiteOpacity8,
      padding: 10,
      position: 'relative',
      color: main,
      fontSize: 14,
      lineHeight: 1.4,
      width: '100%',
      boxShadow: `-1px -1px 3px ${grayC}`,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  };
};

export default styles;
